module.exports = __webpack_public_path__ + "static/media/users.bca7d777.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/users.svg
// module id = 1715
// module chunks = 0